"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_LINK = void 0;
const TEXT_LINK = exports.TEXT_LINK = 'text-link';
